import { VerificationSuccessComponent } from "./verification-success/verification-success.component";
import { VerificationComponent } from "./verification/verification.component";

export const VERIFICATION_ROUTES = [
    { path: '', component: VerificationComponent },
    { path: 'success', component: VerificationSuccessComponent }
] 